import React from "react"
import zain from "../assets/icons/zain_logo.png"
import xgame from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import './Subscribe.scss'

function OTP() {
    console.log('inside OTP container')
    function submitFrom(e){
        e.preventDefault()
        console.log("form is submitted")
    }
    return (
        <div className="container m-w">
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            <figure className="image z-s m-1">
                                <img src={zain} alt="zain logo"/>
                            </figure>
                            <figure className="image l-s m-2">
                                <img src={xgame} alt="xgame logo"/>
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon"/>
                            </figure>
                            <form onSubmit={submitFrom}>
                                <div className="columns is-mobile is-multiline">
                                    <div className="column is-full">
                                    <div className="field">
                                        <label className="label">Enter the OTP</label>
                                        <div className="control">
                                            <input className="input" type="text" placeholder=""/>
                                        </div>
                                        <p className="help">Please enter the OTP send to your mobile</p>
                                    </div>
                                    <div className="control">
                                        <button className="button btn-main">Confirm OTP</button>
                                    </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OTP